import { Directive, inject } from "@angular/core";
import { ModalController } from "@ionic/angular/standalone";

import { BaseComponent } from "@mp/common/base/base.component";

@Directive()
export abstract class BaseModalComponent<V = null | any> extends BaseComponent {
    protected modalCtrl: ModalController;

    protected constructor() {
        super();
        this.modalCtrl = inject(ModalController);
    }

    public closeModal(data?: V): void {
        this.log.debug("Closing modal");
        this.modalCtrl.dismiss(data).catch(err => this.log.warn("Error on dismiss modal", err));
    }
}
